import { render, staticRenderFns } from "./color-fns.vue?vue&type=template&id=7a75405c&lang=pug&"
import script from "./color-fns.vue?vue&type=script&lang=js&"
export * from "./color-fns.vue?vue&type=script&lang=js&"
import style0 from "./color-fns.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./color-fns.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports